// extracted by mini-css-extract-plugin
module.exports = {"company-info":"CompanyInfo_company-info__8ym-j","company-name":"CompanyInfo_company-name__r2Yxb","address":"CompanyInfo_address__2ZbZ2"};